/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".table-sm[_ngcontent-%COMP%]{text-align:center;border-radius:0;margin-bottom:6px;background-color:#000;font-size:14px;max-width:500px!important;width:500px!important}h2[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]{color:#000}"];
export { styles as styles };
